'use strict';

const Help = {
    'ejemplo': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Impedit, minima!',
    'nro_fam': 'Numero de hombres y mujeres de familias beneficiadas',
    'plazo_cierre': 'El plazo cierre por defecto es 60 dias'
};

export default Help;


// WEBPACK FOOTER //
// ./src/app/common/lang/es/help.lang.js